<section class="container">
  <article class="container__content ids-mb-4">
    <h2 class="title ids-text-title-01 ids-mv-5">{{ title }}</h2>
    <p class="subtitle">{{ subtitle }}</p>
    <ids-alert class="container__alert" type="offer" icon="aviso_outline">
      {{ alert }}
    </ids-alert>
  </article>
  <section class="button-generic-start">
    <button class="to-botton" idsButton (click)="goForm()">{{ buttonTitle }}</button>
  </section>
</section>
